import Insight from "../insightClass";
import React from "react";
import { insight24Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight078 = new Insight(
  "21 November 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight24Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-11-21)",
  "",
  `Ocean Winds — the joint venture between EDPR and Engie — has secured a 1.5 GW floating offshore wind lease from The Crown Estate in the Celtic Sea. This is the third and final site awarded under Leasing Round 5, bringing the round’s total floating capacity to 4.5 GW, alongside projects led by Equinor and Gwynt Glas (EDF Renewables UK/ESB). `,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-11-21)</h1>
    <h2></h2>
    <p className="article-date">21 November 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>1. Ocean Winds Secures 1.5 GW Floating Lease in the UK Celtic Sea</h3>
    <p>
      Ocean Winds — the joint venture between EDPR and Engie — has secured a 1.5
      GW floating offshore wind lease from The Crown Estate in the Celtic Sea.
      This is the third and final site awarded under Leasing Round 5, bringing
      the round’s total floating capacity to 4.5 GW, alongside projects led by
      Equinor and Gwynt Glas (EDF Renewables UK/ESB). The three sites together
      are projected to power around four million homes and support more than
      5,000 jobs.
    </p>
    <p>
      The annual lease price is set at £350/MW, providing a relatively moderate
      cost level for future CfD competitiveness. Developers are now required to
      detail supply-chain commitments and port selections, with Port Talbot and
      Bristol emerging as leading contenders for assembly, marshalling and
      fabrication roles. The UK government sees the Celtic Sea as a strategic
      growth engine for achieving its 2030 offshore wind target, especially in
      floating wind commercialisation.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The completion of Round 5 marks the UK’s transition from early
      demonstration to true industrial-scale floating wind deployment. Securing
      a credible third developer reduces market concentration and increases
      competitive pressure across the supply chain. Ports capable of heavy
      fabrication and large-scale logistics now find themselves in a decisive
      window to position for multi-gigawatt floating orders.
    </p>
    <p>
      While floating wind still faces cost and supply-chain uncertainty, the
      modest lease fee provides headroom in future CfD bids. For international
      supply-chain players — including those from Europe and Asia — this is the
      moment to establish local partnerships and capabilities, as the Celtic Sea
      is set to become one of the world’s most strategic floating wind basins.
    </p>
    <h3>
      2. GB Energy Makes Its First Investment: Up to £150m for Pentland Floating
      Wind (Scotland)
    </h3>
    <p>
      The Pentland Floating Offshore Wind Farm (100 MW, off Caithness) has
      secured up to £150 million in investment from GB Energy, the UK’s National
      Wealth Fund, and the Scottish National Investment Bank. This marks GB
      Energy’s first-ever deployment of capital, signalling a new era of
      sovereign-style public investment in early-stage clean-energy projects.
      Pentland is expected to participate in the upcoming AR7 CfD round and is
      positioned as an advanced demonstration-scale project for floating
      technology.
    </p>
    <p>
      As a near-commercial floating array, Pentland is intended to validate
      design concepts, cost assumptions and supply-chain readiness, offering
      lessons that will feed directly into larger-scale Celtic Sea and ScotWind
      developments. The investment consortium emphasised its intention to “crowd
      in” private capital by reducing technology and execution risk at the early
      stage.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This transaction sends a significant policy signal: the UK is prepared to
      use public capital to de-risk floating wind technology and accelerate
      commercialisation. If GB Energy’s co-investment model proves effective, it
      may be replicated for larger multi-GW developments, reshaping the
      financing landscape for high-risk offshore technologies.For OEMs, ports
      and contractors, this creates immediate clarity — demonstration-scale
      floating wind will move ahead, backed by sovereign-level support. For
      international developers and investors, Pentland now stands as a key
      reference project for understanding how the UK will structure floating
      wind financing going forward.
    </p>
    <h3>
      3. UK Government Clarifies Wake-Effect Rules, Easing Developer Disputes
    </h3>
    <p>
      The UK has issued new planning guidance confirming that developers of new
      offshore wind farms are not required to compensate existing wind farms for
      wake-effect–related losses. The government also rejected imposing minimum
      distance requirements between wind farms, stating that scientific
      understanding of wake impacts is still evolving and that prescriptive
      spacing could unnecessarily constrain development.
    </p>
    <p>
      This clarification comes after prolonged disputes involving roughly 10 GW
      of projects, where incumbents argued that new developments would
      significantly erode yields. By removing wake issues from the planning
      system and placing them firmly in the realm of commercial negotiation, the
      government aims to accelerate consenting timelines and reduce regulatory
      uncertainty.
    </p>
    <p>
      Mitigation measures such as curtailment or design changes for the sole
      purpose of protecting incumbent yields were deemed inappropriate if they
      materially compromise a new project’s output.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The new guidance effectively reallocates risk rather than eliminating it.
      For new projects, it significantly reduces consenting uncertainty —
      especially in congested basins like the southern North Sea — and clears a
      major hurdle that has delayed multiple portfolios.
    </p>
    <p>
      For existing projects, however, wake-related yield risk becomes a
      commercial exposure that must now be priced into PPAs, refinancing, and
      life-extension strategies. Developers are likely to adopt new forms of
      cooperation, including data-sharing agreements and layout coordination,
      particularly in regions where several projects share the same wind
      resource.
    </p>
    <p>
      Overall, the UK is shifting toward a more market-driven coexistence
      framework, improving predictability for investors and reducing planning
      bottlenecks.
    </p>
    <h3>
      4. Hornsea 3 Advances as Cadeler Expands Its Installation Fleet and
      Backlog
    </h3>
    <p>
      Cadeler has reported strong year-to-date performance with a 178% rise in
      revenue and an expansion of its fleet from five to nine vessels, with
      plans to reach twelve by 2027. Its newly delivered A-class vessel, Wind
      Ally, will undertake the full monopile transport and installation scope
      for Ørsted’s Hornsea 3 — one of the world’s largest offshore wind farms.
      Other recent vessel deliveries include Wind Maker, Wind Pace and Wind
      Keeper.
    </p>
    <p>
      The company’s order book continues to grow, with additional turbine
      installation contracts in Poland and significant foundation installation
      work worth hundreds of millions of pounds. The accelerating build-out
      reflects tightening vessel supply, rising day-rates, and high utilisation
      across the sector.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Cadeler’s expansion underscores an industry-wide consolidation of
      heavy-lift installation capacity. For developers who have secured vessel
      slots early, this offers confidence in delivery; for others, competition
      for installation windows in the late 2020s is likely to become a material
      project-risk factor.
    </p>
    <p>
      Hornsea 3 is also a milestone for integrated installation contracting,
      with Cadeler responsible for the entire monopile T&I scope. If successful,
      this model may become standard for multi-gigawatt projects, simplifying
      interfaces but concentrating execution risk.
    </p>
    <p>
      For ports, OEMs and Tier-1 contractors, partnering with the small group of
      global installation leaders will be crucial to securing long-term access
      to vessel capacity.
    </p>
    <h3>
      5. Siemens Energy: “Limited Synergies” Between Onshore and Offshore Wind
    </h3>
    <p>
      At its annual results briefing, Siemens Energy stated that synergies
      between its onshore and offshore wind businesses are “more limited than
      people assume”. Siemens Gamesa recorded more than €1.3 billion in losses
      due largely to onshore quality issues, while the offshore segment remains
      relatively strong. The broader Siemens Energy group, however, raised
      profit expectations on the back of robust performance in gas turbines and
      power networks, and announced its first dividend in four years.
    </p>
    <p>
      The company expects its wind division to break even in 2026 and deliver
      modest profits by 2027. Management reiterated its focus on stabilising the
      business rather than divesting assets, despite repeated calls from
      investors to separate the onshore and offshore divisions.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      For the offshore sector, the most important signal is that Siemens’
      offshore turbine business remains intact and on a credible path to
      recovery — essential for the delivery of major UK and European offshore
      wind programmes.
    </p>
    <p>
      The acknowledgement of limited synergy strengthens the argument for
      treating offshore wind as a distinct industrial sector, with its own
      capital requirements and risk profile. This shift could open the door for
      more specialised financing structures, including partial divestments or
      asset-level infrastructure investors.
    </p>
    <p>
      For policymakers, the results reinforce why stable procurement and
      realistic CfD strike prices are critical: OEM balance sheets remain
      fragile, and further shocks would directly impact turbine availability and
      project delivery timelines.
    </p>
    <h3>
      6. TotalEnergies Files Permits for 3 GW of German Offshore Projects, COD
      Shifted to 2031
    </h3>
    <p>
      TotalEnergies has submitted permit applications for two major German
      offshore wind projects: the 2 GW NordseeEnergies 1 in the North Sea and
      the 1 GW OstseeEnergies in the Baltic. Although the company has shifted
      the expected commissioning date from 2030 to 2031, it reaffirmed its
      commitment to the projects.Germany’s Federal Maritime and Hydrographic
      Agency is expected to take up to 18 months to review the documents.
      TotalEnergies emphasised that Germany is its most important European power
      market, with offshore generation intended to support its integrated
      strategy across generation, trading and retail.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      At a time when several developers in Europe and the US are reconsidering
      project commitments, TotalEnergies’ decision to proceed is strategically
      significant. Adjusting timelines is a pragmatic response to supply-chain
      inflation and grid-integration limitations, rather than a sign of
      withdrawal.
    </p>
    <p>
      For Germany’s 2030 and 2035 offshore targets, these 3 GW represent a
      critical component of the long-term energy transition as the country moves
      away from coal and nuclear power.
    </p>
    <p>
      For supply-chain players, the revised timeline offers both planning
      opportunity and potential congestion risk. The 2029–2032 period may see
      many projects simultaneously seeking installation vessels and specialised
      components. This is an important window for UK and Asian suppliers
      considering expansion in the German market.
    </p>
    <h3>
      7. Taiwan’s 180 MW Floating Wind Pilot Gains Strategic Backing from Asia
      Cement
    </h3>
    <p>
      Taiwan’s Rui Li 1 floating offshore wind pilot (180 MW), located off the
      coast of Hsinchu County, has secured Asia Cement Corporation as a major
      local investor. The project — led by IX Renewables in partnership with
      Hexicon, Snow BV and Japan’s GF Corporation — consists of 12 floating
      turbines and is scheduled for commissioning in 2029. The array is expected
      to generate electricity for approximately 205,000 homes.
    </p>
    <p>
      The addition of a major Taiwanese industrial sponsor strengthens the
      project’s bankability and facilitates coordination with local
      stakeholders, including fisheries and municipal authorities. Taiwan aims
      to reach 21 GW of offshore wind capacity by 2035, positioning itself as
      one of Asia’s most important offshore wind markets.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Rui Li 1 is more than a pilot — it is Taiwan’s foundational platform for
      floating wind commercialisation. Local industrial participation
      significantly enhances financing prospects and political alignment, both
      of which are essential in Taiwan’s complex maritime and regulatory
      environment.
    </p>
    <p>
      For European players, Taiwan remains the most active offshore wind proving
      ground outside Europe, especially for typhoon-resistant design, deep-water
      moorings and local content integration. Experience gained here will
      directly benefit future markets in Japan, South Korea and potentially
      China’s deep-water coastal regions.
    </p>
    <p>
      For international investors and suppliers, Taiwan’s floating wind pipeline
      represents a critical strategic bridge between European technology
      leadership and broader Asia-Pacific growth.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
